import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import css_248z from './footer-nav-container.scss.js';
import '../footer-nav/index.js';
import '../footer-accordion/index.js';

class FooterNavContainer extends s {
    render() {
        return $ `<div class="footer-nav-container" role="region" aria-label="Footer navigation"><div class="footer-nav-container__grid"><slot name="nav-desktop"></slot></div><div class="footer-nav-container__accordion"><slot name="nav-accordion"></slot></div></div>`;
    }
}
FooterNavContainer.styles = css_248z;
customElements.define('footer-nav-container', FooterNavContainer);

export { FooterNavContainer };
